export default __webpack_public_path__ + "8d1989f839d2ca6d16bf1de4011fad6d.png";